<mat-form-field [appearance]="appearance" class="field-form tw-w-full">
  <mat-label>{{ inputLabel }}</mat-label>

  <mat-chip-grid #chipList aria-label="Seleccionados">
    <!-- Render de la VISTA (agrupada o no) -->
    <mat-chip-row
      *ngFor="let chip of (viewChips$ | async)!"
      [disabled]="disabled"
      [removable]="true"
      (removed)="removeChip(chip)"
    >
      <!-- Chip individual -->
      <ng-container *ngIf="chip.kind === 'item'">
        {{ chip.item.title }}
      </ng-container>
      <!-- Chip agrupado -->
      <ng-container *ngIf="chip.kind === 'group'">
        {{ chip.title }}
        <span class="tw-ml-2 tw-text-xs tw-opacity-70">({{ chip.count }})</span>
      </ng-container>

      <button matChipRemove *ngIf="!disabled">
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip-row>

    <!-- Input / Autocomplete -->
    <input
      [placeholder]="placeHolder"
      #valueInput
      [formControl]="valueCtrl"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
    />
  </mat-chip-grid>

  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    <mat-option *ngFor="let item of filteredData | async" [value]="item">
      {{ item.title }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
